import { Component, OnInit } from '@angular/core';
import { FinanceiroService } from '../financeiro.service';
import { AcessoApiService } from '../../../acessoApi.service';
import { Router } from '@angular/router';
import { DadosAcessoService } from '../../../dadosAcesso.service';
import { getLocaleDateTimeFormat } from '@angular/common';
import { MessageBundle } from '@angular/compiler';
import { NotificationsService } from 'angular2-notifications';
import * as jsPDF from 'jspdf';
import { summaryFileName } from '@angular/compiler/src/aot/util';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-carta-quitacao',
  templateUrl: './carta-quitacao.component.html',
  styleUrls: ['./carta-quitacao.component.css']
})
export class CartaQuitacaoComponent implements OnInit {

  // atributos carta de quitação
  public cnpj: string = "";
  public nomeCompleto: string = "";
  public endereco: string = "";
  public bairro: string = "";
  public cidade: string = "";
  public uf: string = "";
  public ano: number = 0;
  public dia: number = 0;
  public codLoja: string = "";
  mesNome = new Array("janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro");
  public mes: string = "";
  public arquivo: string = "";
  public mostrarCarta = false;

  constructor(private acessoAPI: AcessoApiService, private router: Router,  private notificacao: NotificationsService) {
    this.codLoja = sessionStorage.getItem('cod_loja');
    this.nomeCompleto = sessionStorage.getItem('nome_completo');
    this.endereco = sessionStorage.getItem('endereco');
    this.uf = sessionStorage.getItem('uf');
    this.cidade = sessionStorage.getItem('cidade');
    this.bairro = sessionStorage.getItem('bairro');
    this.cnpj = sessionStorage.getItem('cnpj');
    this.ano = new Date().getFullYear();
    this.mes = this.mesNome[new Date().getMonth()];
    this.dia = new Date().getDate();
   
  }

  ngOnInit() {
    this.Download()
  }
  VoltarCarta() {
    this.router.navigate(["/financeiro"])
  }

  ExportarCarta() {

    const elementToPrint = document.getElementById('CartaImpressao');
    const pdf = new jsPDF('p', 'pt', 'a4');
    pdf.addHTML(elementToPrint, () => {
      pdf.save(this.codLoja + '_Carta.pdf');
    });

  }
  Download() {
    this.acessoAPI.geCartaQuitacao(this.codLoja) //8507 1645
      .subscribe(retorno => {
        this.arquivo = retorno;
        this.mostrarCarta = true;
      }, err => {
        this.mostrarCarta = false;
        this.notificacao.error(
          'Falha de Autenticação!',
         JSON.stringify(err._body) ,
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )
      }
      );
   
  }

  showpdf() {
    const linksource = `data:application/pdf;base64, ${this.arquivo}`;
    const downloadlink = document.createElement('a');
    const fileName = 'CartaDeQuitação.pdf';
    downloadlink.href = linksource;
    downloadlink.download = fileName;
    downloadlink.click();

  }
}




// WEBPACK FOOTER //
// ./src/app/pages/financeiro/carta-quitacao/carta-quitacao.component.ts